export const FALLBACK_CALENDAR_URL =
  'https://meetings-na2.hubspot.com/start-engine/private-team-meeting';
export const OLD_GENERIC_ROUND_ROBIN = 'https://meetings-na2.hubspot.com/generic_round_robin';

export const GOLD_ROUND_ROBIN_URL =
  'https://meetings-na2.hubspot.com/start-engine/gold-round-robin';

/**
 * Canada (`/ca/landing-page`, `/ca/offering/[slug]`) books directly with the
 * Canadian rep rather than the US sales-agent round robin.
 */
export const CANADA_CALENDAR_URL = 'https://meetings-na2.hubspot.com/warren-aarons';

export const ISH_MEETING_URL = 'https://meetings-na2.hubspot.com/ishmael-badze';
export const JACK_MEETING_URL = 'https://meetings-na2.hubspot.com/jack-marecki';
